import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
  UniqueIdentifier,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { ETableCell } from "./e-table";
import { ReactNode } from "react";
import { Button } from "../ui/button";

/**
 * NOTE: Kept in separate file to avoid coupling e-table to here, for now.
 */

export function DragNDropWrapper({
  children,
  items,
  handleDragEnd,
  disabled,
}: {
  children: ReactNode;
  items: (
    | UniqueIdentifier
    | {
        id: UniqueIdentifier;
      }
  )[];
  handleDragEnd: (event: DragEndEvent) => void;
  disabled?: boolean;
}) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items}
        strategy={verticalListSortingStrategy}
        disabled={disabled}
      >
        {children}
      </SortableContext>
    </DndContext>
  );
}

export function ETableCellDragNDropGrip({
  id,
  disabled,
}: {
  id: UniqueIdentifier;
  disabled?: boolean;
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <ETableCell ref={setNodeRef} style={style} className="w-8 p-0 text-center">
      <Button
        {...attributes}
        {...listeners}
        variant="ghost"
        type="button"
        className="hover:bg-muted w-8 cursor-grab rounded p-1 disabled:cursor-default disabled:opacity-50"
        disabled={disabled}
      >
        <GripVertical className="text-muted-foreground h-4 w-4" />
      </Button>
    </ETableCell>
  );
}
